import { createSelector } from 'reselect';

export const uiSelector = state => state.ui;

export const legendVisibilitySelector = createSelector(
  uiSelector,
  subState => subState.legendOpened
);

export const mobileMapVisibilitySelector = createSelector(
  uiSelector,
  subState => subState.mobileMapOpened
);
